<template>
  <dv-border-box-9>
    <!-- <h2 class="title">1</h2> -->
    <div style="width: 600px" :style="heightStyle">
      <c-tabs :index="0" @tabClick="tabClick" style="padding: 30px 15px 20px 20px">
        <div class="tab_item_div" label="图片">
          <img class="img_icon" :src="imgSrc" />
        </div>
        <div class="tab_item_div" label="视频">
          <div :id="videoId" class="video_div"></div>
        </div>
      </c-tabs>
    </div>
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
import { imgView } from '@/api/api'
import Tabs from './Tabs'
import ProjectImage from '@/assets/default_img.png'
import EZUIKit from 'ezuikit-js'
import { htmlUrl, ysyVideoUrl } from '@/api/api'
export default {
  name: 'PictureView',
  components: {
    'c-tabs': Tabs,
  },
  props: ['videoId', 'heightStyle'],
  data() {
    return {
      url: {
        // 获取项目图片
        projectImg: '/project/projectImg/list_img',
        // 获取项目视频
        projectVideo: '/project/projectVideo/listUserAll',
      },
      imgSrc: ProjectImage,
      // 当前是图片还是视频 0是图片 1是视频 默认为0
      type: 0,
      // 第一个页面是否加载
      isLoading1: false,
      // 第二个页面是否加载
      isLoading2: false,
      // 当前项目id
      projectId: null,
      // 视频直播源
      player: null,
    }
  },
  async mounted() {},
  methods: {
    // 重新加载数据
    reloadData(projectId) {
      this.projectId = projectId
      this.isLoading1 = false
      this.isLoading2 = false
      this.loadData()
    },
    // 加载数据 渲染视图
    async loadData() {
      if (!this.projectId) {
        return
      }
      if (this.type == 0) {
        if (this.isLoading1 == true) {
          return
        }
        const result = await this.getProjectImage()
        console.log('imgresult', result)
        this.imgSrc = ProjectImage
        if (result.result.length > 0) {
          // 有图片就取第一张
          this.imgSrc = imgView + result.result[0].url

          this.isLoading1 = true
        }
      } else {
        if (this.isLoading2 == true) {
          return
        }
        const result2 = await this.getProjectVideo()
        if (result2.result.length > 0) {
          // 有视频就取第一个视频
          const item = result2.result[0]
          this.resetPlayer()
          // 清空节点下dom元素
          document.getElementById(this.videoId).innerHTML = ''
          // setTimeout(() => {
          this.player = new EZUIKit.EZUIKitPlayer(
            {
              autoplay: true,
              id: this.videoId,
              accessToken: item.accessToken,
              url: item.url,
              template: 'standard', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
              // 视频上方头部控件
              //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
              //plugin: ['talk'],                       // 加载插件，talk-对讲
              // 视频下方底部控件
              // footer: ['talk', 'broadcast', 'hd', 'fullScreen'], // 如果template参数不为simple,该字段将被覆盖
              // footer: ['fullscreen'], // 如果template参数不为simple,该字段将被覆盖
              // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
              // openSoundCallBack: data => console.log("开启声音回调", data),
              // closeSoundCallBack: data => console.log("关闭声音回调", data),
              // startSaveCallBack: data => console.log("开始录像回调", data),
              // stopSaveCallBack: data => console.log("录像回调", data),
              // capturePictureCallBack: data => console.log("截图成功回调", data),
              // fullScreenCallBack: data => console.log("全屏回调", data),
              // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
              // width: 600,
              // height: 400,
            },
            100
          )
          // })
          this.isLoading2 = true
        }
      }
    },
    // 停止直播 清空视频源
    resetPlayer() {
      if (this.player) {
        this.player.stop()
        this.player = null
      }
    },
    /**
     * @description: 获取服务数据
     * @param {undefined}
     * @return {Promise}
     */
    async getProjectImage() {
      // 180
      return await getAction(this.url.projectImg + '?projectId=' + this.projectId)
    },
    async getProjectVideo() {
      // 247
      return await getAction(this.url.projectVideo + '?proIds=' + this.projectId)
    },
    // tab改变
    tabClick(index) {
      this.type = index
      this.loadData()
    },
  },
}
</script>
<style>
.iframe-btn-container {
  background: rgba(59, 144, 230, 0.65);
}
</style>
<style lang='less' scoped>
.title {
  text-align: center;
  margin: 0;
  // margin-bottom: 24px;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
.border-box-content {
  padding: 24px;
}
.tab_item_div {
  height: 100%;
}
.img_icon,
.video_div {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
</style>
